import ExamGridResultSquare from './ExamGridResultSquare';

export default ExamGridResultSquare;
